const css = require('./contacts.css');
const signals = require('../../signals/contacts');

class Contacts {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(signals.onLoad);
    }
}

module.exports = {
    constructor: Contacts
};



// WEBPACK FOOTER //
// ./components/contacts/index.js